<div class="card card-box mb-5">
    <div class="row no-gutters">
        <div class="col-xl-6">
            <div class="hero-wrapper bg-composed-wrapper bg-grow-early h-100 rounded-left">
                <div class="flex-grow-1 w-100 d-flex align-items-center">
                    <div class="bg-composed-wrapper--image rounded-left"
                         style="background-image: url('assets/images/hero-bg/hero-3.jpg');"></div>
                    <div class="bg-composed-wrapper--bg bg-second opacity-5 rounded-left"></div>
                    <div class="bg-composed-wrapper--content text-center p-5">
                        <div class="text-white">
                            <h1 class="display-3 my-3 font-weight-bold">
                                Wonderful serenity has possession
                            </h1>
                            <p class="font-size-lg mb-0 text-white-50">
                                A free hour, when our power of choice is untrammelled and when nothing prevents.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="hero-footer pb-4">
                    <a [routerLink]="" class="btn btn-second px-4">
                        <span class="btn-wrapper--label">
                            Continue reading
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-xl-6">
            <div class="card-tr-actions">
                <button class="btn btn-sm btn-neutral-dark" tooltip="Send Message" type="button">
                    <span class="btn-wrapper--icon">
                        <fa-icon [icon]="['far', 'envelope']"></fa-icon>
                    </span>
                </button>
            </div>
            <div class="text-center pt-4">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-90">
                        <div class="rounded-circle overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar7.jpg"/>
                        </div>
                    </div>
                </div>
                <div>
                    <span class="badge my-2 badge-neutral-success text-success font-size-md px-4 py-1 h-auto">Online</span>
                </div>
                <h3 class="font-weight-bold mt-3">Lacie-Mae Mckay</h3>
                <p class="mb-0 text-black-50">Senior Frontend Developer at <b>Google Inc.</b></p>
                <div class="pt-3">
                    <button class="btn d-50 m-2 p-0 btn-github" tooltip="Github" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-instagram" tooltip="Instagram" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-google" tooltip="Google" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
                <div class="d-flex p-4 bg-secondary card-footer mt-4 flex-wrap">
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-warning line-height-1"
                                           name="settings"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Reports</div>
                                <div class="font-size-md mb-1 text-black-50">Monthly Stats</div>
                            </div>
                        </button>
                    </div>
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-success line-height-1" name="grid"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Statistics</div>
                                <div class="font-size-md mb-1 text-black-50">Customers stats</div>
                            </div>
                        </button>
                    </div>
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-danger line-height-1" name="users"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Projects</div>
                                <div class="font-size-md mb-1 text-black-50">Manage servers</div>
                            </div>
                        </button>
                    </div>
                    <div class="w-50 p-2">
                        <button class="btn card card-box text-left d-flex justify-content-center px-4 py-3 w-100"
                                type="button">
                            <div>
                                <i-feather class="h1 d-block mb-4 text-first line-height-1" name="layers"></i-feather>
                                <div class="font-weight-bold font-size-lg text-black">Tasks</div>
                                <div class="font-size-md mb-1 text-black-50">Pending items</div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
